export default "__VITE_ASSET__DsOP_Zri__"